import React from 'react';
import styles from '../components/forms/ConnectSalesforceForm/ConnectSalesforceForm.module.scss';
const ADMIN_AUTH_LINK =
  'https://developer.salesforce.com/docs/commerce/commerce-api/guide/authorization-for-admin-apis.html';
const SHOPPER_API_LINK =
  'https://developer.salesforce.com/docs/commerce/commerce-api/guide/authorization-for-shopper-apis.html';

export const salesforceFieldsDescriptions = [
  {
    title: 'Client ID',
    key: 'client_id',
    path: 'auth',
    content: (
      <>
        <p>
          To get <strong>Client ID</strong> - Go to <strong>Account Manager</strong> and follow the Instructions:{' '}
          <a className={styles.tooltipLink} target="_blank" href={ADMIN_AUTH_LINK} rel="noreferrer">
            Salesforce Developers
          </a>
        </p>
        <p>Authorization for Admin APIs - Client ID </p>
        <p>Example: "9d2d21ba-fc9c-439a-8337-8817339bde83".</p>
      </>
    ),
  },
  {
    title: 'Client Secret',
    key: 'client_secret',
    path: 'auth',
    content: (
      <>
        <p>
          To get Client Secret - Go to <strong>Account Manager</strong> and follow the Instructions:{' '}
          <a target="_blank" className={styles.tooltipLink} href={SHOPPER_API_LINK} rel="noreferrer">
            Salesforce Developers
          </a>
        </p>
        <p> Authorization for Shopper APIs - Client Secret </p>
        <p>
          {' '}
          <strong>Note:</strong> To generate <strong>Client Secret</strong>, use <strong>Client ID</strong> from Admin
          APIs.{' '}
        </p>
        <p>Example: "IQPH9KHDxtBQrBQEbwIALBwN2WRy-7KOVgBWttz1XTT".</p>
      </>
    ),
  },
  {
    title: 'Client Password',
    key: 'client_password',
    path: 'auth',

    content: (
      <>
        <p>
          To get Client ID - Go to <strong>Account Manager</strong> and follow the Instructions:{' '}
          <a target="_blank" className={styles.tooltipLink} href={ADMIN_AUTH_LINK} rel="noreferrer">
            Salesforce Developers
          </a>
        </p>

        <p> Authorization for Admin APIs - Client Password</p>

        <p>Exmaple: "qs0hFb77Hr1LpEdhLQfw".</p>
      </>
    ),
  },
  {
    title: 'Short Code',
    key: 'short_code',
    path: 'api',
    content: (
      <>
        <p>
          The short code is an eight-character string that is assigned to a realm for routing purposes. The short code
          applies to your entire realm, across all instances.
        </p>
        <p>The short code is in the same place as the organization ID. To look it up:</p>
        <ol className={styles.tooltipOl}>
          <li>Go to the Business Manager URL for your instance.</li>
          <li>
            Log in using your <strong>Account Manager</strong> credentials.
          </li>
          <li>
            Go to <strong>Administration</strong> &gt; <strong> &gt; Site Development</strong> >{' '}
            <strong>Salesforce Commerce API Settings.</strong>
          </li>
        </ol>
        <p>If you’ve never used the B2C Commerce API in your realm, click Request Short Code to request one.</p>
        <p>
          It can take up to 24 hours for the short code to propagate through the CDN and all the routing systems in your
          configuration.
        </p>

        <p>Example: "kv7kzm78".</p>
      </>
    ),
  },
  {
    title: 'Tenant',
    key: 'tenant',
    path: 'api',
    content: (
      <>
        <p>
          B2C Commerce instance is considered a "tenant" when it is associated with a supporting system, such as the
          Shopper Login and API Access Service (SLAS).
        </p>

        <p>To associate an instance with a system like SLAS, you must identify the instance with a tenant ID.</p>

        <p>A tenant ID begins with a four-character realm ID, followed by an underscore (_) and an instance ID.</p>

        <p>Example: "zzrf_s01". </p>
      </>
    ),
  },
  {
    title: 'Site ID',
    key: 'site_id',
    path: 'api',

    content: (
      <>
        <p>
          The site ID is the name of the site (sometimes called a "channel") for which you want to access data. For
          example: RefArch or SiteGenesis.
        </p>
        <p>To see a list of sites in Business Manager:</p>
        <ol className={styles.tooltipOl}>
          <li> Go to the Business Manager URL for your instance.</li>
          <li>
            Log in using your <strong>Account Manager</strong> credentials.
          </li>
          <li>
            Go to <strong>Administration</strong> &gt; <strong>Sites</strong> &gt; <strong>Manage Sites</strong>.
          </li>
        </ol>

        <p>Example: "RefArch".</p>
      </>
    ),
  },
  {
    title: 'Organization ID',
    key: 'organization_id',
    path: 'api',
    content: (
      <>
        <p>
          The organization ID is a short string that identifies a B2C Commerce instance. Each instance gets its own
          unique organization ID, such as f_ecom_zzte_053.
        </p>
        <p>
          You can look up the organization ID for an instance through Business Manager. You must have the Business
          Manager Administrator role in <strong>Account Manager</strong> and know the Business Manager URL for the
          instance.
        </p>
        <p>A Business Manager URL looks like this:</p>
        <p>https://zzte-053.dx.commercecloud.salesforce.com/on/demandware.store/Sites-Site</p>
        <p>To look up the organization ID:</p>
        <ol className={styles.tooltipOl}>
          <li>Go to the Business Manager URL for your instance.</li>
          <li>
            Log in using your <strong>Account Manager</strong> credentials.
          </li>
          <li>
            Go to <strong>Administration</strong> &gt; <strong> &gt; Site Development</strong> >{' '}
            <strong>Salesforce Commerce API Settings.</strong>
          </li>
        </ol>
        <p>
          The organization ID is displayed on the page. Click Copy to Clipboard and paste it in a location that is easy
          to refer to later.
        </p>
      </>
    ),
  },
];
